import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/Button';

type ShowMoreProps = {
  increaseAmount: () => void;
};

export const ShowMore: FC<ShowMoreProps> = ({ increaseAmount }) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center mt-5 mb-9" data-test="show-more-button">
      <Button
        label={t('linksOrButtons:showMore')}
        variant="secondary"
        onClick={() => increaseAmount()}
      />
    </div>
  );
};
